// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1WJ9Q","footer":"ModalFilter_footer__1fHcc"};